import React, { createContext, useContext, useState } from "react";

const CallActionContext = createContext();

export const CallActionProvider = ({ children }) => {
  const [showSidebarActions, setShowSidebarActions] = useState(false);

  return (
    <CallActionContext.Provider
      value={{ showSidebarActions, setShowSidebarActions }}
    >
      {children}
    </CallActionContext.Provider>
  );
};

export const useCallAction = () => useContext(CallActionContext);
